import React, { useEffect } from "react";
import { useIsFocused } from "@react-navigation/native";
import { _goToAddAttribute } from "routers/helper";

import { View, SafeAreaView } from "react-native";
import {
  Error,
  Empty,
  Header,
  Loading,
  AttributeBox,
  AddButtonFloat,
  AnimatedInfinityList,
} from "components";

import { useAttributes } from "clients/apis";

import { sizes, strings } from "assets/constants";
import { mq } from "utils";
import css from "styles";
import { useChmod } from "hooks";

export default function Attributes() {
  const { chmod } = useChmod();

  const isFocused = useIsFocused();

  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    hasNextPage,
    isRefetching,
    fetchNextPage,
    isFetchingNextPage,
  } = useAttributes();

  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  const _renderItem = (items: []) => {
    return (
      <View style={css.responsiveListContainer}>
        {items.map((attr: AttributeT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <AttributeBox attr={attr} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty style={{ marginTop: mq(20) }} message={strings.no_attr} />;
    }

    return (
      <AnimatedInfinityList
        responseData={data}
        onRefresh={refetch}
        paddingTop={sizes.space}
        paddingBottom={50}
        renderItemList={_renderItem}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    );
  };

  return (
    <>
      <Header title={strings.product_attrs} />
      <>
        <SafeAreaView style={{ ...css.container, ...css.screenBg }}>
          {_renderContent()}
          {chmod("attribute", "POST") && (
            <AddButtonFloat onPress={_goToAddAttribute} />
          )}
        </SafeAreaView>
      </>
    </>
  );
}
